var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "container",
    attrs: {
      "id": "navContainer"
    }
  }, [_c('nav', {
    staticClass: "navbar is-light"
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/GetCoi-Logo.png"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.away),
      expression: "away"
    }],
    staticClass: "navbar-burger burger",
    attrs: {
      "data-target": "navbarExampleTransparentExample"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleActive('navEllipsisMobile')
      }
    }
  }, [(_vm.user.email) ? _c('div', {
    ref: "navEllipsisMobile",
    staticClass: "dropdown",
    staticStyle: {
      "margin-top": "12px",
      "margin-left": "10px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu",
    attrs: {
      "id": "dropdown-menu3",
      "role": "menu"
    }
  }, [_c('div', {
    staticClass: "dropdown-content"
  }, [_c('a', {
    staticClass: "dropdown-item",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("\n                      Logout\n                    ")])])])]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-menu",
    attrs: {
      "id": "navMenuTransparentExample"
    }
  }, [_c('div', {
    staticClass: "navbar-start"
  }, [_c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/documentation"
    }
  }, [_vm._v("Getting Started")]), _vm._v(" "), (_vm.user.email) ? _c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/associations"
    }
  }, [_vm._v("Associations")]) : _vm._e(), _vm._v(" "), (_vm.user.email) ? _c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/requests"
    }
  }, [_vm._v("Requests")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-end"
  }, [_c('div', {
    staticClass: "navbar-item"
  }, [(_vm.user.email) ? [_c('span', {
    attrs: {
      "id": "email"
    }
  }, [_vm._v(_vm._s(_vm.user.email))]), _vm._v(" "), _c('div', {
    ref: "navEllipsis",
    staticClass: "dropdown",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c('div', {
    staticClass: "dropdown-trigger"
  }, [_c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.away),
      expression: "away"
    }],
    staticClass: "icon is-small fa-button",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleActive('navEllipsis')
      }
    }
  }, [_c('i', {
    staticClass: " fa fa-ellipsis-h"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu",
    attrs: {
      "id": "dropdown-menu3",
      "role": "menu"
    }
  }, [_c('div', {
    staticClass: "dropdown-content"
  }, [_c('a', {
    staticClass: "dropdown-item",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("\n                          Logout\n                        ")])])])])] : _vm._e()], 2)])])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "52px",
      "padding-bottom": "50px"
    }
  }, [_c('router-view')], 1)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dropdown-trigger"
  }, [_c('div', {
    staticClass: "icon is-small fa-button"
  }, [_c('i', {
    staticClass: "fa fa-ellipsis-h"
  })])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25441132","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1XP8
// module chunks = 1